module.exports = __webpack_public_path__ + "images/application/templates/overlay@2x-6d409039.png";